import CreateHotelClassificationRequestModelBase from '../_generated/modelBases/create-hotel-classification-request-model-base';

export default class CreateHotelClassificationRequestModel extends CreateHotelClassificationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
